import { cva } from 'class-variance-authority';

const tableHeadBaseStyles = ['uppercase', 'px-6', 'py-3'];

const tableHeadStylesSAG = cva([
  ...tableHeadBaseStyles,
  'text-[#000028]',
  'dark:text-white',

  'hover:text-[#005159]',
  'hover:border-[#005159]',
  'border-b',
  'border-[#9999A9]',
  
  'dark:hover:bg-[#001F39]',
  'dark:hover:text-[#00FFB9]',
  'dark:border-[#737389]',
]);

const tableHeadStylesSHS = cva([
  ...tableHeadBaseStyles,
  'text-[#1a1a1a]',
  'bg-white',
  'hover:bg-[#f2f2f2]',
  'border-b',
  'border-[#b3b3b3]',

  'dark:bg-black',
  'dark:text-[#e6e6e6]',
  'dark:hover:bg-[#1a1a1a]',
  'dark:border-[#4d4d4d]',
]);

export { tableHeadStylesSAG, tableHeadStylesSHS };
